// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const UserCheckOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 32 32","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M13.5 16.32a6.8 6.8 0 10-6.8-6.8c0 3.76 3.05 6.8 6.8 6.8zm0-11.1a4.3 4.3 0 11-4.3 4.3 4.3 4.3 0 014.3-4.3zm0 12.31A13.1 13.1 0 00.8 27.68l-.02.08a1.25 1.25 0 00.95 1.48v.01a1.25 1.25 0 001.49-.95 10.53 10.53 0 0120.54-.07l.02.07a1.25 1.25 0 102.44-.55v.01A13.12 13.12 0 0013.5 17.53zm17.34-6.82a1.24 1.24 0 00-1.76.08l-4.38 4.78-.82-.82a1.25 1.25 0 00-2.13.89c0 .34.14.65.36.88l1.76 1.74.02.02.01.02c.08.06.16.11.25.15h.01l.12.08a.79.79 0 00.63.06c.11 0 .22-.03.32-.07l.17-.1c.08-.05.16-.1.23-.17l.01-.01.03-.02 5.25-5.74a1.24 1.24 0 00-.08-1.77z"}}]},"name":"user-check","theme":"outlined"};

const UserCheckOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={UserCheckOutlinedSvg} />;
  UserCheckOutlined.displayName = 'UserCheckOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(UserCheckOutlined);
